export function expandSelectedUserIdsWithAgents(userIds, userStore) {
    const normalizedIds = (userIds ?? []).filter((id) => id != null);
    const nonAgentUserIds = [];

    for (const userId of normalizedIds) {
        const profile = userStore.getUserProfileById(userId);

        if (!profile || !profile.is_agent) {
            nonAgentUserIds.push(userId);
        }
    }

    const expandedIds = new Set(nonAgentUserIds);

    for (const userId of nonAgentUserIds) {
        const profile = userStore.getUserProfileById(userId);

        if (profile?.agent_id) {
            expandedIds.add(profile.agent_id);
        }
    }

    return [...expandedIds];
}

export function buildGroupMembershipInviteProfileIds({
    selectedUserIds,
    userStore,
    activeConversation,
}) {
    const participants = new Map();

    activeConversation?.participants?.forEach((participant) => {
        const isSelected = (selectedUserIds ?? []).includes(participant.id);

        if (!isSelected) {
            return;
        }

        participants.set(participant.id, participant);

        if (!participant.is_agent && participant.agent_id) {
            const agentProfile = userStore.getAgentProfileById(
                participant.agent_id,
            );

            if (agentProfile) {
                participants.set(participant.agent_id, agentProfile);
            }
        }
    });

    expandSelectedUserIdsWithAgents(selectedUserIds, userStore).forEach(
        (userId) => {
            const profile =
                userStore.getUserProfileById(userId) ??
                participants.get(userId);

            if (profile) {
                participants.set(profile.id, profile);
            }

            if (profile && !profile.is_agent && profile.agent_id) {
                const agentProfile = userStore.getAgentProfileById(
                    profile.agent_id,
                );

                if (agentProfile) {
                    participants.set(agentProfile.id, agentProfile);
                }
            }
        },
    );

    return [...participants.keys()];
}
